module.exports = __webpack_public_path__ + "img/roundabout.5b142dc1.svg";